var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5C5 4.46243 7.46243 2 10.5 2C13.1907 2 15.432 3.93318 15.907 6.48668C15.9736 6.84475 16.2297 7.1383 16.5754 7.25295C18.5661 7.9132 20 9.79045 20 12C20 14.7614 17.7614 17 15 17C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19C18.866 19 22 15.866 22 12C22 9.10754 20.2462 6.62697 17.7463 5.55958C16.8909 2.358 13.9717 0 10.5 0C6.35786 0 3 3.35786 3 7.5C3 7.60028 3.00197 7.70014 3.00589 7.79955C1.21048 8.8354 0 10.7754 0 13C0 16.3137 2.68629 19 6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C3.79086 17 2 15.2091 2 13C2 11.3427 3.00818 9.91848 4.44865 9.31168C4.86549 9.13609 5.11256 8.70256 5.05119 8.25443C5.01748 8.00826 5 7.75644 5 7.5Z",
    fill: "#475367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3356 12.2526C10.7145 11.9158 11.2855 11.9158 11.6644 12.2526L13.1644 13.5859C13.5771 13.9528 13.6143 14.5849 13.2474 14.9977C12.9264 15.3588 12.4025 15.4325 12 15.1996V20C12 20.5523 11.5523 21 11 21C10.4477 21 10 20.5523 10 20V15.1996C9.5975 15.4325 9.07358 15.3588 8.75259 14.9977C8.38567 14.5849 8.42285 13.9528 8.83564 13.5859L10.3356 12.2526Z",
    fill: "#475367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.23698c365e330c430fcfa7c659903050.svg";
export { ForwardRef as ReactComponent };